import { NavigationExtras, Params } from '@angular/router';

import { serializeRouterNavOptions } from './router-nav-state.utilities';
import { RouterPath, RouterRefreshOptions } from './router-nav-state.model';
import { Customer } from '../../../models/customer.models';

export class GoToAgencyAdmin {
  static type = '[RouterNav] Agency Admin';

  constructor(readonly customer: Customer) {}
}

export class ChangeCustomer {
  static type = '[RouterNav] Change Customer';

  readonly toJSON = () => ({
    ...this,
    type: ChangeCustomer.type,
  });

  constructor(
    readonly customerId: number,
    readonly path?: RouterPath,
    readonly options?: RouterRefreshOptions,
  ) {}
}

export class GoTo {
  static type = '[RouterNav] Go To';

  readonly toJSON = () => ({
    ...this,
    type: GoTo.type,
    options: serializeRouterNavOptions(this.options),
  });

  constructor(
    readonly path: RouterPath,
    readonly options?: NavigationExtras,
  ) {}
}

export class GoToRefresh {
  static type = '[RouterNav] Go To Refresh';

  constructor(
    readonly path: RouterPath,
    readonly queryParams: Params,
    readonly options?: RouterRefreshOptions,
  ) {}
}
